export const FOOTER_COMPANY_CONTENT = {
  description: 'TheMaithil helps families discover verified pandits, transparent service packages, and dependable booking support for rituals at home or venue.',
  whatsappLabel: 'Message on WhatsApp'
};
